import React from 'react'
import ReactDOM from 'react-dom'

import './index.scss'

import App from './App'
import * as serviceWorker from './serviceWorker'
import { AuthProvider } from './contexts/AuthContext'
import { DataProvider } from './contexts/DataContext'

ReactDOM.render(
  <AuthProvider>
    <DataProvider>
      <App />
    </DataProvider>
  </AuthProvider>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
